import React from 'react'
import {Grid} from 'semantic-ui-react'

import {User} from './User'
import {PagSeguro} from './PagSeguro'

export const Params = () => {

    const userData = JSON.parse(sessionStorage.getItem('Data'))

    return (
        <Grid>
            <Grid.Row columns={"equal"}>
                <Grid.Column>
                    <User item={userData} />
                </Grid.Column>
                <Grid.Column>
                    <PagSeguro item={userData.place}/>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}